import React, {Component} from 'react';
import PrintTwoPagesDoc from './PrintTwoPagesDoc';

class PrintTwoPagesCashBillDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintTwoPagesDoc
        title={'บิลเงินสด'} 
        doc={'cashbill_doc'}
        docNo={this.props.cbNo}
        param={'cb'}
      >
      </PrintTwoPagesDoc>
    )
  }
}  

export default PrintTwoPagesCashBillDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintTwoPagesCashBillDoc.js